import { fetchReservation } from '../actions/reservation';
import { getEventPriceLevels } from '../actions/event';
import { getEventSeriesChildListing } from '../views/series/actions/event-series';
import { setSkipMembership, setHasMembershipContext } from '@/actions/ui';

/**
 * After membership logout (or clearing membership context), refresh reservation and listing-related data.
 * @param {string} token reservation token
 * @param {string} secret reservation secret
 * @param {boolean} isRecurring whether the listing is recurring
 * @param {Object|null} selectedChildEvent event object if child event selected
 */
export const membershipLogoutAndRefresh = (
  token,
  secret,
  isRecurring,
  selectedChildEvent
) => async (dispatch) => {
  dispatch(setSkipMembership(false));
  dispatch(setHasMembershipContext(false));

  await dispatch(fetchReservation(token, secret));

  if (isRecurring && selectedChildEvent) {
    await dispatch(getEventSeriesChildListing(selectedChildEvent.event_id));
  } else {
    await dispatch(getEventPriceLevels());
  }
};
